import React from 'react'
import { NavLink } from 'react-router-dom'
import { Nav } from 'reactstrap'

import { Navmenudropdown, Navmenugroup } from 'components'

import { withTranslation } from 'react-i18next'
import altProfileImg from '../../assets/img/profile.svg'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
import api from '../../api/api'
import { processError } from '../../lib/lib'
import Skeleton from '../UI/Skeleton'
const cookies = new Cookies()

class Sidebar extends React.Component {
    constructor(props) {
        super(props)
        this.activeRoute.bind(this)
        this.state = {
            opendd: '',
            username: '',
            useravatar: '',
            profileInfoLoaded: false,
            profileImageLoaded: false,
            imageLoaded: false,
            dataLoaded: false,
        }
        this.handleOpendd = this.handleOpendd.bind(this)
    }
    handleOpendd(open) {
        if (this.state.opendd === open) {
            this.setState({
                opendd: '',
            })
        } else {
            this.setState({
                opendd: open,
            })
        }
    }

    // verifies if routeName is the one active (in browser input)
    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1
            ? ' active'
            : ''
    }

    getProfileInfo(token) {
        return new Promise((resolve, reject) => {
            api.profileInfo(token)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getProfileImage(token) {
        return new Promise((resolve, reject) => {
            api.getProfileImage(token)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    componentDidMount() {
        const token = cookies.get('accessToken')
        let arrPromise = [
            this.getProfileInfo(token).then(({ status, data }) => {
                if (status === "ok") {
                    let username = `${data.profileFirstName || ''} ${data.profileLastName || ''}`
                    username = (username === ' ') ? "Noname" : username
                    this.setState({ username })
                }
                this.setState({ profileInfoLoaded: true })
            }),
            this.getProfileImage(token).then((profileImage) => {
                if (profileImage.status === "ok") {
                    const useravatar = profileImage.data.medium
                    this.setState({ useravatar })
                }
                this.setState({ profileImageLoaded: true })
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        const children = (child) => {
            const links = []
            if (child) {
                for (let i = 0; i < child.length; i++) {
                    links.push(
                        <li key={i}>
                            <NavLink
                                to={child[i].path}
                                className="nav-link"
                                activeClassName="active"
                            >
                                <span>{t(child[i].name)}</span>
                            </NavLink>
                        </li>,
                    )
                }
                return <Nav>{links}</Nav>
            }
        }
        return (
            <div className="sidebar menubar" data-color="white">
                <div className="sidebar-wrapper" ref="sidebar">
                    <div className="profile-info">
                        <div className="profile-image col-12 text-center">
                            <a href="/profile">
                                {!this.state.imageLoaded && (this.state.useravatar || altProfileImg) && <Skeleton circle={true} height={75} width={75} image={true} className="img-fluid rounded-circle" />}
                                {(this.state.useravatar || altProfileImg) && <img onLoad={() => this.setState({ imageLoaded: true })} alt="" src={this.state.useravatar || altProfileImg} className={`img-fluid rounded-circle${this.state.imageLoaded ? '' : ' d-none'}`} />}
                            </a>
                        </div>
                        <div className="profile-details col-12 text-center">
                            <h3 className="custom-title">
                                {
                                    this.state.profileInfoLoaded ?
                                        <a href="/profile">{this.state.username}</a>
                                        :
                                        <Skeleton />
                                }
                            </h3>
                        </div>
                    </div>
                    <div className="sidebar-scroll">
                        <Nav className="navigation">
                            {this.props.routes.map((prop, key) => {
                                if (prop.redirect) return null
                                if (prop.type === 'child') return null
                                if (prop.type === 'navgroup') {
                                    return <Navmenugroup name={prop.name} key={key}></Navmenugroup>
                                }
                                if (prop.type === 'dropdown') {
                                    const IconComponent = prop.icon
                                    return (
                                        <li
                                            className={this.state.opendd === prop.name ? 'active' : ''}
                                            data-toggle="collapse"
                                            key={key}
                                        >
                                            <a
                                                to={prop.path}
                                                className="nav-link"
                                                onClick={() => this.handleOpendd(prop.name)}
                                            >
                                                <IconComponent className="sidebar-icon" />
                                                <p>{prop.name}</p>
                                                <span className="badge">{prop.badge}</span>
                                                <span className={'arrow fa fa-chevron-left'}></span>
                                            </a>
                                            {children(prop.child)}
                                        </li>
                                    )
                                }

                                if (prop.type === 'dropdown-backup') {
                                    return (
                                        <Navmenudropdown
                                            name={prop.name}
                                            icon={prop.icon}
                                            path={prop.path}
                                            badge={prop.badge}
                                            child={prop.child}
                                            key={key}
                                            openclass={
                                                this.state.opendd === prop.name ? 'activethis' : ''
                                            }
                                            onClick={() => this.handleOpendd(prop.name)}
                                        ></Navmenudropdown>
                                    )
                                }
                                const IconComponent = prop.icon
                                return (
                                    <li
                                        className={this.activeRoute(prop.path)}
                                        key={key}
                                        onClick={() => this.handleOpendd(prop.name)}
                                    >
                                        <NavLink
                                            to={prop.path}
                                            className="nav-link"
                                            activeClassName="active"
                                        >
                                            <IconComponent className="sidebar-icon" />
                                            <p>{t(prop.name)}</p>
                                            <span className="badge">{prop.badge}</span>
                                        </NavLink>
                                    </li>
                                )
                            })}
                        </Nav>
                    </div>
                    {/* <div class="menustats">

                    <h5>Project Progress</h5>
                    <div class="progress">
                                <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{width: 50+'%'}}>
                            </div>
                        </div>
                    <h5>Target Achieved</h5>
                    <div class="progress">
                                <div class="progress-bar progress-bar-accent" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: 70+'%'}}>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        )
    }
}

Sidebar.propTypes = {
    location: PropTypes.object,
    t: PropTypes.func,
    routes: PropTypes.array,
    history: PropTypes.object,
}

export default withTranslation()(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx